
export const USER_SCREENS_ACCESS = 'user_screen_access'